import {
  buildPhoneNumberFieldFilter,
} from "@shared/helpers/normalize-phone-for-search";
import { generateHyperFilterFromPath } from "@shared/helpers/sql-relations";
import React from "react";
import type { ClassType } from "remult";
import type { EntityFilter } from "remult";
import type { HyperTableFilter } from "./filter-types";
import {
  getPhoneFilterStateFromMeta,
  PhoneNumberFilterInput,
} from "./inner-components/hyper-table-toolbar/filter-types/PhoneNumberFilterInput";
type EntityWithHyperFilter = ClassType<any> & {
  hyperFilter: (filter: any) => EntityFilter<any>;
};

export function createPhoneNumberFilter(
  entity: EntityWithHyperFilter,
  options: {
    fieldName: string;
    id: string;
    caption?: string;
  },
): HyperTableFilter<any> {
  return {
    icon: "string",
    fieldName: options.fieldName,
    caption: options.caption ?? "מספר טלפון",
    id: options.id,
    renderFilter: ({ onSave, meta }) => {
      const { value, mode } = getPhoneFilterStateFromMeta(meta);

      const handleChange = (input: string, searchMode: typeof mode) => {
        const phoneFilter = buildPhoneNumberFieldFilter(input, searchMode);

        onSave({
          value: phoneFilter
            ? entity.hyperFilter(
              generateHyperFilterFromPath(
                entity,
                options.fieldName,
                phoneFilter,
              ),
            )
            : {},
          meta: { value: input, searchMode },
        });
      };

      return (
        <PhoneNumberFilterInput
          value={value}
          mode={mode}
          onChange={handleChange}
        />
      );
    },
  };
}
